import { Badge, BadgeProps, styled } from '@mui/material';
import { PopoverTrigger } from 'src/components/PopoverTrigger';
import Iconify from 'src/components/iconify';
import Image from 'src/components/image';
import { useLivekitRTCState } from 'src/provider/VoiceChannel/livekit/useLivekitRTCState';
import { VirtualBackgroundPickerPopover } from './VirtualBackgroundPickerPopover';

export const EffectsVirtualBackgroundEdit = () => {
  const { filterParams } = useLivekitRTCState();

  return (
    <PopoverTrigger
      popover={VirtualBackgroundPickerPopover}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      <StyledBadge
        badgeContent={<Iconify icon="tabler:pencil" width={12} height={12} />}
      >
        <StyledImage src={filterParams.virtualBackground} />
      </StyledBadge>
    </PopoverTrigger>
  );
};

const StyledImage = styled(Image)(({ theme }) => ({
  width: theme.spacing(4),
  height: theme.spacing(4),
  borderRadius: theme.spacing(1),
}));

const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: theme.spacing(0.5),
    top: theme.spacing(3),
    width: theme.spacing(2.5),
    height: theme.spacing(2.5),
    padding: theme.spacing(0.25),
    border: `2px solid ${theme.palette.background.paper}`,
    backgroundColor: theme.palette.text.secondary,
  },
}));
